import { useState, useEffect, useCallback } from 'react';
import cn from 'classnames';

import ScrollTopAnimation from 'common/helpers/ScrollTopAnimation';

import ScrollBtn from './assets/scroll-top-button';
import styles from './index.module.css';

interface IScrollTopButton {
  scrollElementRef?: any;
}

const ScrollTopButton = ({ scrollElementRef }: IScrollTopButton) => {
  const [isVisible, changeVisible] = useState(false);

  useEffect(() => {
    if (scrollElementRef) {
      // eslint-disable-next-line no-param-reassign
      scrollElementRef.onscroll = () => {
        if (scrollElementRef.scrollTop > 20) {
          changeVisible(true);
        } else {
          changeVisible(false);
        }
      };
    }

    return () => {
      if (scrollElementRef) {
        // eslint-disable-next-line no-param-reassign
        scrollElementRef.onscroll = null;
      }
    };
  }, [scrollElementRef]);

  const handleScrollToTop = useCallback(
    (event) => {
      event.preventDefault();
      ScrollTopAnimation(scrollElementRef, 300);
    },
    [scrollElementRef],
  );

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      onClick={handleScrollToTop}
      className={cn(styles.scrollTopButton, {
        [styles.scrollTopButtonVisibleYes]: isVisible,
      })}
    >
      <ScrollBtn />
    </div>
  );
};

export default ScrollTopButton;
